import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import './index.css';
import NavBar from './components/Navbar';
import ErrorPage from './components/ErrorPage';
import ConstructionPage from './components/ConstructionPage';
import Hero from './components/Hero';
import Contact from './components/Contact';
import Projects from './components/Projects';


const router = createBrowserRouter([
  {
    path: "/",
    element: <><NavBar/><Hero/></>,
    errorElement:<><NavBar/><ErrorPage/></>
  },
  // {
  //   path: "/outreach",
  //   element: <><NavBar/><ReachOut /></>,
  //   errorElement:<><NavBar/><ErrorPage/></>
  // },
  {
    path: "/projects",
    element: <><NavBar/><Projects /></>,
    errorElement:<><NavBar/><ErrorPage/></>
  },
  {
    path: "/tech",
    element: <><NavBar/><ConstructionPage /></>,
    errorElement:<><NavBar/><ErrorPage/></>
  },
  {
    path: "/contact",
    element: <><NavBar/><Contact /></>,
    errorElement:<><NavBar/><ErrorPage/></>
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);